// extracted by mini-css-extract-plugin
export var cruiseCounter = "InlineToggleFilter-module--cruise-counter--c44d9";
export var cruiseCounterDisabled = "InlineToggleFilter-module--cruise-counter-disabled--616d0";
export var fixLabelAlign = "InlineToggleFilter-module--fix-label-align--f2ba4";